import '../styles/components/PageTitle.css';

interface Props {
  title: string;
}

export function PageTitle({ title }: Props) {
  return (
    <div className="page-title-wrapper">
      <h1 className="page-title">{title}</h1>
    </div>
  );
}
